export default "__VITE_PUBLIC_ASSET__bca0dffe__"